const isNonNullish = (input) => {
  return input != null;
};
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};
export {
  imageThumbnail,
  link
};
//# sourceMappingURL=isFilled.js.map
